export const faresSearchCriteria = [
   {
      screen: 'FARES',
      config: [
         {
            sectionName: 'Table',
            sectionKey: 'table',
            fields: [
               {
                  field: 'active',
                  key: 'Active',
                  fullName: 'Active Fares',
                  disabled: true,
                  inputType: 'checkBox',
                  defaultChecked: true,
               },
               {
                  field: 'inactive',
                  key: 'Inactive',
                  fullName: 'Inactive Fares',
                  disabled: true,
                  inputType: 'checkBox',
               },
               {
                  field: 'historical',
                  key: 'Historical',
                  fullName: 'Historical Fares',
                  disabled: true,
                  inputType: 'checkBox',
               },
               {
                  field: 'winningFare',
                  key: 'WIN',
                  fullName: 'Winning Fares',
                  inputType: 'checkBox',
                  disabled: true,
               },
            ],
         },

         {
            sectionName: 'Products',
            sectionKey: 'productType',
            fields: [
               {
                  field: 'specified',
                  key: 'Spec',
                  fullName: 'Specified Fares',
                  disabled: false,
                  inputType: 'checkBox',
               },
               {
                  field: 'constructed',
                  key: 'Cons',
                  fullName: 'Constructed Fares',
                  disabled: false,
                  inputType: 'checkBox',
               },
               {
                  field: 'web',
                  key: 'Web',
                  fullName: 'Web Fares',
                  disabled: true,
                  inputType: 'checkBox',
               },
               {
                  field: 'fbr',
                  key: 'FBR',
                  fullName: 'Fare Basis Rule',
                  disabled: true,
                  inputType: 'checkBox',
               },
            ],
         },
         {
            sectionName: 'Search',
            sectionKey: 'search',
            fields: [
               {
                  field: 'marketId',
                  key: 'MKT LST',
                  fullName: 'Market List ID',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'ABC123',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Identifier',
            sectionKey: 'identifiers',
            fields: [
               {
                  field: 'origin',
                  key: 'ORG',
                  fullName: 'Origin',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'destination',
                  key: 'DES',
                  fullName: 'Destination',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'carrier_code',
                  key: 'CXR',
                  fullName: 'Carrier Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'fareClassCode',
                  key: 'FBC',
                  fullName: 'Fare Class Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 8,
                  dataType: 'string',
                  placeHolder: 'ABCD1234',
                  inputType: 'text',
               },
               {
                  field: 'tariffNumber',
                  key: 'TAR',
                  fullName: 'Tariff Number',
                  validationName: 'NUMERIC',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'footnoteCode',
                  key: 'FT',
                  fullName: 'Footnote Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'routingNumber',
                  key: 'RTG',
                  fullName: 'Routing',
                  validationName: 'NUMERIC',
                  characterLimit: 4,
                  dataType: 'string',
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'constructionMethod',
                  key: 'CON',
                  fullName: 'Construction Method',
                  validationName: 'ALPHA',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'A',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Fare Value',
            sectionKey: 'fareValues',
            fields: [
               {
                  field: 'vendorChangeCode',
                  key: 'VCC',
                  fullName: 'Vendor Change Code',
                  validationName: 'ALPHA',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'roundTripIndicator',
                  key: 'OWRT',
                  fullName: 'OW/RT Indicator',
                  validationName: 'NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode',
                  key: 'CUR',
                  fullName: 'Currency Code',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'fareAmount',
                  key: 'AMT',
                  fullName: 'Fare Amount',
                  validationName: 'AMOUNT',
                  dataType: 'string',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'surchargeAmount',
                  key: 'SUR',
                  fullName: 'Surcharge',
                  validationName: 'AMOUNT',
                  dataType: 'string',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'yqAmount',
                  key: 'YQ',
                  fullName: 'YQ',
                  validationName: 'AMOUNT',
                  dataType: 'string',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'yrAmount',
                  key: 'YR',
                  fullName: 'YR',
                  validationName: 'AMOUNT',
                  dataType: 'string',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'aggregatedTax',
                  key: 'TAX',
                  fullName: 'Tax',
                  validationName: 'AMOUNT',
                  dataType: 'string',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'totalFare',
                  key: 'TTL',
                  fullName: 'Total Fare',
                  validationName: 'AMOUNT',
                  dataType: 'string',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Rule',
            sectionKey: 'rules',
            fields: [
               {
                  field: 'ruleNumber',
                  key: 'RULE',
                  fullName: 'Rule Number',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 4,
                  dataType: 'string',
                  placeHolder: 'AB12',
                  inputType: 'text',
               },
               {
                  field: 'dow',
                  key: 'DOW',
                  fullName: 'Day of the Week',
                  validationName: 'DOW',
                  dataType: 'string',
                  placeHolder: '123 | 123',
                  inputType: 'text',
               },
               {
                  field: 'ruleSeasonDates',
                  key: 'SEAS DT',
                  fullName: 'Season Dates',
                  validationName: 'ALPHA_NUMERIC_WITH_PIPE',
                  dataType: 'string',
                  placeHolder: '31DEC99-31DEC99',
                  inputType: 'text',
               },
               {
                  field: 'advancePurchaseReservation',
                  key: 'AP',
                  fullName: 'Advance Purchase',
                  validationName: 'NUMERIC',
                  dataType: 'string',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'ruleTravelDates',
                  key: 'RULE TVL DT',
                  fullName: 'Rule Travel Dates',
                  validationName: 'ALPHA_NUMERIC_WITH_PIPE',
                  dataType: 'string',
                  placeHolder: '31DEC99-31DEC99',
                  inputType: 'text',
               },
               {
                  field: 'applicableDates',
                  key: 'APPL DT',
                  fullName: 'Applicable Dates',
                  validationName: 'ALPHA_NUMERIC_WITH_PIPE',
                  dataType: 'string',
                  placeHolder: '31DEC99-31DEC99',
                  inputType: 'text',
               },
               {
                  field: 'minStay',
                  key: 'MIN ST',
                  fullName: 'Minimum Stay',
                  validationName: 'ALPHA_NUMERIC_WITH_STAR',
                  dataType: 'string',
                  placeHolder: '1234QWE',
                  inputType: 'text',
               },
               {
                  field: 'maxStay',
                  key: 'MAX ST',
                  fullName: 'Maximum Stay',
                  validationName: 'NUMERIC',
                  characterLimit: 3,
                  dataType: 'number',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'ruleBlackOutDates',
                  key: 'BO DT',
                  fullName: 'Blackout Dates',
                  validationName: 'ALPHA_NUMERIC_WITH_PIPE',
                  dataType: 'string',
                  placeHolder: '31DEC99-31DEC99',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Footnote',
            sectionKey: 'footnotes',
            fields: [
               {
                  field: 'footnoteReservationFromDate',
                  key: 'FST RES',
                  fullName: 'First Reservation Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: '31DEC99',
                  inputType: 'datePicker',
               },
               {
                  field: 'footnoteReservationToDate',
                  key: 'LST RES',
                  fullName: 'Last Reservation Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: '31DEC99',
                  inputType: 'datePicker',
               },
               {
                  field: 'footnoteTicketingFromDate',
                  key: 'FST TKT',
                  fullName: 'First Ticketing Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: '31DEC99',
                  inputType: 'datePicker',
               },
               {
                  field: 'footnoteTicketingToDate',
                  key: 'LST TKT',
                  fullName: 'Last Ticketing Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: '31DEC99',
                  inputType: 'datePicker',
               },
               {
                  field: 'footnoteOutboundTravelFromDate',
                  key: 'TVL ST',
                  fullName: 'Travel Start Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: '31DEC99',
                  inputType: 'datePicker',
               },
               {
                  field: 'footnoteOutboundTravelToDate',
                  key: 'TVL END',
                  fullName: 'Travel End Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: '31DEC99',
                  inputType: 'datePicker',
               },
               {
                  field: 'footnoteOutboundTravelCompleteDate',
                  key: 'TVL CMPLT',
                  fullName: 'Travel Complete Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: '31DEC99',
                  inputType: 'datePicker',
               },
               {
                  field: 'footnoteTravelDates',
                  key: 'FT TVL DT',
                  fullName: 'Footnote Travel Dates',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: '31DEC99-31DEC99',
                  inputType: 'text',
               },
               {
                  field: 'footnoteSeasonDates',
                  key: 'FT SEAS DT',
                  fullName: 'Footnote Season Dates',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: '31DEC99-31DEC99',
                  inputType: 'text',
               },
               {
                  field: 'footnoteBlackOutDates',
                  key: 'FT BO DT',
                  fullName: 'Footnote Blackout Dates',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: '31DEC99-31DEC99',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Distributions',
            sectionKey: 'distributions',
            fields: [
               {
                  field: 'effectiveDate',
                  key: 'EFF DT',
                  fullName: 'Effective Date',
                  validationName: 'DATE_STRING',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: '31DEC99',
                  inputType: 'datePicker',
               },
               {
                  field: 'discontinueDate',
                  key: 'DISC DT',
                  fullName: 'Discontinue Date',
                  validationName: 'DATE_STRING',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: '31DEC99',
                  inputType: 'datePicker',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  characterLimit: null,
                  dataType: 'string',
                  placeHolder: '31DEC99 13:00',
                  inputType: 'text',
               },
               {
                  field: 'gfsUniqueFillingCode',
                  key: 'GFS',
                  fullName: 'GFS Filing Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'AB1',
                  inputType: 'text',
               },
               {
                  field: 'gfsDate',
                  key: 'GFS DT',
                  fullName: 'GFS Date',
                  validationName: 'DATE_STRING',
                  dataType: 'number',
                  placeHolder: '31DEC99',
                  inputType: 'datePicker',
               },
               {
                  field: 'status',
                  key: 'STATUS',
                  fullName: 'Fare Status',
                  validationName: 'ALPHA',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dgNumber',
                  key: 'DG',
                  fullName: 'Distribution Group',
                  validationName: 'NUMERIC',
                  characterLimit: 6,
                  dataType: 'number',
                  placeHolder: '123456',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Fare Class',
            sectionKey: 'fareClass',
            fields: [
               {
                  field: 'cabinCode',
                  key: 'CAB',
                  fullName: 'Cabin Code',
                  validationName: 'ALPHA',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'rbds',
                  key: 'RBD',
                  fullName: 'RBD',
                  validationName: 'ALPHA',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareTypeCode',
                  key: 'FTC ',
                  fullName: 'Fare Type Code',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'dayOfWeekTypeCode',
                  key: 'DOW TC',
                  fullName: 'Day Of Week Type Code',
                  validationName: 'ALPHA',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'seasonTypeCode',
                  key: 'SEAS TC',
                  fullName: 'Season Type Code',
                  validationName: 'ALPHA',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'passengerTypes',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'ticketDesignators',
                  key: 'TKT DSG',
                  fullName: 'Ticket Designators',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'AB12',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Brand',
            sectionKey: 'brands',
            fields: [
               {
                  field: 'brand',
                  key: 'BRD',
                  fullName: 'Brand',
                  validationName: 'NUMERIC',
                  disabled: true,
                  characterLimit: 3,
                  dataType: 'number',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'brandDetails',
                  key: 'BRD DET',
                  fullName: 'Brand Details',
                  cellstyle: { textAlign: 'right' },
                  validationName: 'NUMERIC',
                  disabled: true,
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Market',
            sectionKey: 'markets',
            fields: [
               {
                  field: 'originCountryCode',
                  key: 'OC',
                  fullName: 'Origin Country Code',
                  validationName: 'ALPHA',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: 'AB',
                  inputType: 'text',
               },
               {
                  field: 'destinationCountryCode',
                  key: 'DC',
                  fullName: 'Destination Country Code',
                  validationName: 'ALPHA',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: 'AB',
                  inputType: 'text',
               },
               {
                  field: '',
                  key: 'MKT',
                  fullName: 'Market',
                  disabled: true,
                  validationName: 'AMOUNT',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: '',
                  key: 'SRC',
                  fullName: 'Source',
                  validationName: 'ALPHA_NUMERIC',
                  disabled: true,
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: '',
                  key: 'TIER',
                  fullName: 'Market Tier',
                  validationName: 'ALPHA_NUMERIC',
                  disabled: true,
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: '',
                  key: 'MKT GRP',
                  fullName: 'Market Group',
                  validationName: 'ALPHA_NUMERIC',
                  disabled: true,
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: '',
                  key: 'MKT TYP',
                  fullName: 'Market Type',
                  validationName: 'ALPHA_NUMERIC',
                  disabled: true,
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: '',
                  key: 'MKT AST',
                  fullName: 'Market Analyst',
                  validationName: 'ALPHA_NUMERIC',
                  disabled: true,
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: '',
                  key: 'MKT CAT',
                  fullName: 'Market Category',
                  validationName: 'ALPHA_NUMERIC',
                  disabled: true,
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Origin Addon',
            sectionKey: 'originAddons',
            isConfinedTo: ['Cons'],
            fields: [
               {
                  field: 'gatewayCityCode',
                  key: 'GWT CITY',
                  fullName: 'Gateway City Code',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'fareClassCode',
                  key: 'FCC',
                  fullName: 'Fare Class Code',
                  validationName: 'ALPHA_NUMERIC_WITH_STAR',
                  characterLimit: 8,
                  dataType: 'string',
                  placeHolder: 'ABCD123*',
                  inputType: 'text',
               },
               {
                  field: 'footnoteCode',
                  key: 'FT',
                  fullName: 'Footnote Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: 'arbTariffNumber',
                  key: 'TAR',
                  fullName: 'Addon Tariff Number',
                  validationName: 'NUMERIC',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'fareAmount',
                  key: 'AMT',
                  fullName: 'Addon Amount',
                  validationName: 'NUMERIC',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode',
                  key: 'CUR',
                  fullName: 'Currency Code',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Destination Addon',
            sectionKey: 'destinationAddons',
            isConfinedTo: ['Cons'],
            fields: [
               {
                  field: 'gatewayCityCode',
                  key: 'GWT CITY',
                  fullName: 'Gateway City Code',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'fareClassCode',
                  key: 'FCC',
                  fullName: 'Fare Class Code',
                  validationName: 'ALPHA_NUMERIC_WITH_STAR',
                  characterLimit: 8,
                  dataType: 'string',
                  placeHolder: 'ABCD123*',
                  inputType: 'text',
               },
               {
                  field: 'footnoteCode',
                  key: 'FT',
                  fullName: 'Footnote Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: 'arbTariffNumber',
                  key: 'TAR',
                  fullName: 'Addon Tariff Number',
                  validationName: 'NUMERIC',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'fareAmount',
                  key: 'AMT',
                  fullName: 'Addon Amount',
                  validationName: 'NUMERIC',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode',
                  key: 'CUR',
                  fullName: 'Currency Code',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Specified Fare',
            sectionKey: 'specifiedFares',
            isConfinedTo: ['Cons'],
            fields: [
               {
                  field: 'specifiedFareOrigin',
                  key: 'SPEC ORG',
                  fullName: 'Specified Fare Origin',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFareDestination',
                  key: 'SPEC DEST',
                  fullName: 'Specified Fare Destination',
                  validationName: 'ALPHA',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFareAmount',
                  key: 'SPEC AMT',
                  fullName: 'Specified Fare Amount',
                  validationName: 'NUMERIC',
                  characterLimit: 11,
                  dataType: 'string',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFareCurrency',
                  key: 'SPEC CURR',
                  fullName: 'Specified Fare Currency',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
            ],
         },
      ],
   },
];

export default faresSearchCriteria;
